module.exports = __webpack_public_path__ + "static/media/la-regular-400.338f6f87.woff";